<template>
  <div
    class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 text-left mt-3"
    v-if="avulso"
  >

    <transition name="esocial-modal-fade">
      <div class="esocial-modal-overlay" v-if="showProcedimento" @click.self="showProcedimento = false">
        <div class="esocial-modal">
          <div class="esocial-modal__header">
            <span class="esocial-modal__title">Inserir Novo Risco</span>
            <button type="button" class="esocial-modal__close" @click="showProcedimento = false">
              <i class="fa fa-times"></i>
            </button>
          </div>

          <div class="esocial-modal__body">
            <ed-input-auto-complete
              class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 pa-0"
              label="Pesquisar risco"
              v-model="bind.procedimento"
              :items="bind.procedimentos"
              :loading="bind.loadingProcedimento"
              @search="getRisco"
              clearable
              is-object
            />
          </div>

          <div class="esocial-modal__footer">
            <button type="button" class="esocial-search__btn esocial-search__btn--filter" @click="inserirProcedimento">
              <i class="fa fa-check"></i> Adicionar
            </button>
          </div>
        </div>
      </div>
    </transition>

    <div class="item-group mt-2">
      Informações sobre as atividades
    </div>

    <div class="row">
      <ed-input-date
        class="col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3"
        label="Início das Atividades"
        v-model="formData.ambiente.dtIniCondicao"
        name="valor.ambiente.dtIniCondicao"
        required
      />

      <ed-input-text
        class="col-xs-12 col-sm-12 col-md-9 col-lg-9 col-xl-9"
        label="Descrição das Atividades"
        v-model="formData.ambiente.dscAtivDes"
        name="valor.Atividades"
        required
      />
    </div>

    <div class="item-group mt-2">
      Informações relativas ao responsável pelos registros ambientais.
    </div>

    <div class="row">
      <ed-input-text
        class="col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3"
        label="Nome do Responsavel"
        v-model="formData.responsavel.nome"
        name="valor.responsavel.nome"
        required
      />

      <ed-input-text
      class="col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3"
        label="CPF do Responsavel"
        v-model="formData.responsavel.cpfResp"
        name="valor.responsavel.cpfResp"
        required
      />

      <ed-input-select
      class="col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3"
        label="Órgão de Classe"
        :items="[
          { id: 1, nome: 'Conselho Regional de Medicina - CRM' },
          { id: 4, nome: 'Conselho Regional de Engenharia e Agronomia - CREA' },
          { id: 9, nome: 'Outros' },
        ]"
        v-model="formData.responsavel.ideOC"
        name="valor.responsavel.ideOC"
      />

      <ed-input-text
        class="col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3"
        label="Número de Incrição de Classe"
        v-model="formData.responsavel.nrOC"
        name="valor.responsavel.nrOC"
        type="number"
        required
      />


      <ed-input-select
        class="col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3"
        label="Unidade Federativa"
        name="valor.responsavel.ufOC"
        :items="parent.bind.estados"
        v-model="formData.responsavel.ufOC"
        required
      />
    </div>

    <div class="item-group mt-2">
      Agente(s) nocivo(s) ao(s) qual(is) o trabalhador está exposto. - Tabela 24
      do eSocial
    </div>

    <div class="row">
      <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
        <button type="button" class="esocial-search__btn esocial-search__btn--add" @click="showProcedimento = !showProcedimento">
          <i class="fa fa-plus-circle"></i> Inserir Novo Risco
        </button>

        <div class="procedimentos-table procedimentos-table--riscos">
          <table>
            <thead>
              <tr>
                <th class="procedimentos-table__col-codigo">Código</th>
                <th>Risco</th>
                <th>Descrição</th>
                <th>Tipo de avaliação</th>
                <th>Intensidade ou concentração</th>
                <th>Limite de tolerância</th>
                <th>Unidade de medida</th>
                <th class="procedimentos-table__col-acoes"></th>
              </tr>
            </thead>
            <tbody>
              <tr v-if="!formData.riscos.length">
                <td colspan="8" class="procedimentos-table__empty">Nenhum risco cadastrado</td>
              </tr>
              <tr v-for="(risco, index) in formData.riscos" :key="index">
                <td>{{ risco.codigo }}</td>
                <td>{{ risco.nome }}</td>
                <td>
                  <ed-input-text
                    v-model="risco.dscAgNoc"
                    :key="'dscAgNoc-'+index"
                  />
                </td>
                <td>
                  <ed-input-select
                    :items="[
                      { id: 1, nome: 'Critério quantitativo' },
                      { id: 2, nome: 'Critério qualitativo' },
                    ]"
                    v-model="risco.tpAval"
                    :key="'tpAval-'+index"
                  />
                </td>
                <td>
                  <ed-input-text
                    v-model="risco.intConc"
                    v-mask="'money'"
                    :key="'intConc-'+index"
                  />
                </td>
                <td>
                  <ed-input-text
                    v-model="risco.limTol"
                    v-mask="'money'"
                    :key="'limTol-'+index"
                  />
                </td>
                <td>
                  <ed-input-select
                    :items="[
                    { id: 1, nome: 'dose diária de ruído' },
                    { id: 2, nome: 'decibel linear (dB (linear))' },
                    { id: 3, nome: 'decibel (C) (dB(C))' },
                    { id: 4, nome: 'decibel (A) (dB(A))' },
                    { id: 5, nome: 'metro por segundo ao quadrado (m/s2)' },
                    { id: 6, nome: 'metro por segundo elevado a 1,75 (m/s1,75)' },
                    { id: 7, nome: 'parte de vapor ou gás por milhão de partes de ar contaminado (ppm)' },
                    { id: 8, nome: 'miligrama por metro cúbico de ar (mg/m3)' },
                    { id: 9, nome: 'fibra por centímetro cúbico (f/cm3)' },
                    { id: 10, nome: 'grau Celsius (ºC)' },
                    { id: 11, nome: 'metro por segundo (m/s)' },
                    { id: 12, nome: 'porcentual' },
                    { id: 13, nome: 'lux (lx)' },
                    { id: 14, nome: 'unidade formadora de colônias por metro cúbico (ufc/m3)' },
                    { id: 15, nome: 'dose diária' },
                    { id: 16, nome: 'dose mensal' },
                    { id: 17, nome: 'dose trimestral' },
                    { id: 18, nome: 'dose anual' },
                    { id: 19, nome: 'watt por metro quadrado (W/m2)' },
                    { id: 20, nome: 'ampère por metro (A/m)' },
                    { id: 21, nome: 'militesla (mT)' },
                    { id: 22, nome: 'microtesla (μT)' },
                    { id: 23, nome: 'miliampère (mA)' },
                    { id: 24, nome: 'quilovolt por metro (kV/m)' },
                    { id: 25, nome: 'volt por metro (V/m)' },
                    { id: 26, nome: 'joule por metro quadrado (J/m2)' },
                    { id: 27, nome: 'milijoule por centímetro quadrado (mJ/cm2)' },
                    { id: 28, nome: ' milisievert (mSv)' },
                    { id: 29, nome: 'milhão de partículas por decímetro cúbico (mppdc)' },
                    { id: 30, nome: 'umidade relativa do ar (UR (%))' },

                  ]"
                    v-model="risco.unMed"
                    :required="risco.tpAval == 1"
                    :key="'unMed-'+index"
                  />
                </td>
                <td>
                  <button type="button" class="procedimentos-table__delete" title="Remover risco" @click="removerProcedimento(index)">
                    <i class="fa fa-trash"></i>
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Fct from "common/fct";
import {
  EdInputText,
  EdInputDate,
  EdInputAutoComplete,
  EdInputSelect,
  EdInputSelectTipo,
} from "template";

export default {
  name: "esocial-s2240",
  mixins: [Fct],
  components: {
    EdInputText,
    EdInputDate,
    EdInputAutoComplete,
    EdInputSelect,
    EdInputSelectTipo,
  },

  props: {
    avulso: {
      type: Number,
      default: 0,
    },
    formData: {
      type: Object,
      default: function () {
        return {};
      },
    },
    parent: {
      type: Object,
      default: function () {
        return {};
      },
    },
  },

  watch: {
    "parent.response"() {
      this.formataLista();
    },
  },

  data() {
    return {
      bind: {
        procedimento: null,
        procedimentos: [],
        loadingProcedimento: false,
      },
      showProcedimento: false,
      tableHead: [
        {
          key: "empresa",
          sortable: true,
          show_fdt: true,
          show_empresa_link: true,
          label: "Empresa",
        },
        {
          key: "funcionario",
          sortable: true,
          show_funcao: true,
          show_funcionario_link: true,
          label: "Funcionário",
        },
        {
          key: "consulta",
          sortable: true,
          show_consulta_link: true,
          label: "Consulta",
        },
        {
          key: "pgr",
          sortable: true,
          label: "PPRA/PGR",
        },
        {
          key: "ghe",
          sortable: true,
          label: "GHE (SETOR)",
        },
        {
          key: "lote",
          sortable: true,
          show_lote_recibo: true,
          label: "Lote / Recibo",
        },
        {
          key: "tipo_status",
          sortable: true,
          label: "Status",
        },
        {
          key: "motivo_falha_geracao_label",
          sortable: true,
          label: "Motivo da Falha",
        },
        {
          key: "updated_at",
          sortable: true,
          show_user: true,
          label: "Atualização",
          info: "Data da última alteração deste evento: mudança de status, geração de XML ou vínculo a lote.",
        },
      ],
    };
  },

  mounted() {
    if (!this.avulso) {
      this.formataLista();
    } else {
      this.getRisco();
    }
  },

  methods: {
    inserirProcedimento() {

      if (this.bind.procedimento) {
        let encontrado = false;

        this.formData.riscos.forEach((element) => {
          if (element.codigo == this.bind.procedimento.codigo) {
            encontrado = true;
          }
        });

        if (encontrado) {
          this.$root.$dialog.alert("Procedimento já foi inserido", "warning");
          return;
        }

        this.formData.riscos.push({
          codigo: this.bind.procedimento.codigo,
          nome: this.bind.procedimento.nome,
          dscAgNoc: null,
          tpAval: 1,
          intConc:null,
          limTol:null,
          unMed:null,
          tecMedicao:null
        });
        this.showProcedimento = !this.showProcedimento;
      }
    },

    removerProcedimento(index) {
      this.formData.riscos.splice(index, 1);
      this.$forceUpdate()
    },

    getRisco(_search) {
      this.bind.procedimentos = [];
      this.bind.loadingProcedimento = false;

      this.$root.$request
        .get("esocial/tabelas/conteudo/24", {
          search: _search,
          pagination: 100,
        })
        .then((result) => {
          this.bind.loadingProcedimento = false;

          if (result.status == 200) {
            result.data.data.forEach((element) => {
              let item = {
                id: element.id,
                codigo: element.codigo,
                nome: element.codigo + " - " + element.nome,
              };

              if (item.nome.length > 50) {
                item.nome = item.nome.substring(0, 100);
              }

              this.bind.procedimentos.push(item);
            });
          }
        });
    },

    errosMatricula: function (data) {
      // Sem código de ocorrência confirmado ainda para "matrícula/categoria inválida":
      // até termos um caso real em produção, usamos busca por texto em log_erro
      // (log_erro_codigo já fica persistido para permitir migrar para um filtro por código depois).
      var termos = ["matrícula", "matricula", "categoria"];

      return (data.log_erro || []).filter(function (msg) {
        var msgLower = (msg || "").toLowerCase();
        return termos.some(function (termo) {
          return msgLower.indexOf(termo) != -1;
        });
      });
    },

    formataLista: function () {
      var result = this.parent.response;

      this.parent.tableHead = this.tableHead;

      if (!result.data || !result.data.data) {
        this.parent.tableData = [];
        return;
      }

      var tableData = [],
        arrData = result.data.data;

      for (var i = 0; i < arrData.length; i++) {
        console.log('i '+i)
        
        arrData[i]._nome =
          arrData[i].empresa.nome + " - " + arrData[i].funcionario.nome;
        arrData[i].funcao = arrData[i].funcionario.funcao
          ? arrData[i].funcionario.funcao
          : null;
        arrData[i].fdt = arrData[i].funcionario.fdt
          ? arrData[i].funcionario.fdt
          : null;
        arrData[i].ghe = arrData[i].ghe ? arrData[i].ghe : null;

        let pgr = "";

        if (arrData[i].ghe && arrData[i].ghe.revisao) {
          pgr =
            arrData[i].ghe.revisao.rev +
            " (" +
            arrData[i].ghe.revisao.descricao +
            ")";

          if (arrData[i].ghe.revisao.parent) {
            pgr +=
              " / " +
              arrData[i].ghe.revisao.parent.rev +
              " (" +
              arrData[i].ghe.revisao.parent.descricao +
              ")";
          }

          pgr =
            '<a target="_blank" href="' +
            this.$root.$session.env.url_cs +
            "/app/ppra.php?emp=" +
            arrData[i].empresa.id +
            "&pcmso=" +
            (arrData[i].funcionario  && arrData[i].funcionario.fdt ? arrData[i].funcionario.fdt.id  : '')+
            "&rev=" +
            (arrData[i].ghe && arrData[i].ghe.revisao ? arrData[i].ghe.revisao.id : '') +
            "&ghe=" +
            (arrData[i].ghe  ? arrData[i].ghe.id  : '') +
            '" arget="_blank">' +
            pgr +
            "</a>";
        }

        var item = {
          consulta: arrData[i].id_con ? arrData[i].id_con : "---",
          pgr: pgr,
          empresa: arrData[i].empresa.nome,
          ghe:
            '<span style="color:' +
            (
              arrData[i].tipo_status && arrData[i].tipo_status.id === 380
                ? "orange"
                : (arrData[i].tipo_status ? arrData[i].tipo_status.cor : "")
            ) +
            '">' +
            (arrData[i].ghe
              ? arrData[i].ghe.ghe + " (" + arrData[i].ghe.descricao.trim() + ")"
              : "---") +
            "</span>",
          funcionario: arrData[i].funcionario.nome,
          tipo_status: arrData[i].tipo_status ? arrData[i].tipo_status.descricao: null,
          motivo_falha_geracao_label: arrData[i].motivo_falha_geracao_label || "",
          id: arrData[i].id,
          lote: arrData[i].lote || "",
          recibo:
            '<span style="color:' +
            (
              arrData[i].tipo_status && arrData[i].tipo_status.id === 380
                ? "orange"
                : (arrData[i].tipo_status ? arrData[i].tipo_status.cor : "")
            ) +
            '">' +
            (arrData[i].recibo ? arrData[i].recibo : "---") +
            "</span>",
          updated_at:
            '<span style="color:' +
            (
            arrData[i].tipo_status && arrData[i].tipo_status.id === 380
              ? "orange"
              : (arrData[i].tipo_status ? arrData[i].tipo_status.cor : "")
          ) +
            '">' +
            this.toDate(arrData[i].updated_at, false) +
            "</span>",
          dt_cad:
            '<span style="color:' +
            (
              arrData[i].tipo_status && arrData[i].tipo_status.id === 380
                ? "orange"
                : (arrData[i].tipo_status ? arrData[i].tipo_status.cor : "")
            ) +
            '">' +
            this.toDate(arrData[i].created_at, false) +
            "</span>",
          funcao: arrData[i].funcao ? arrData[i].funcao.nome : null,
          tipo_status:
            '<span style="color:' +
            (
              arrData[i].tipo_status && arrData[i].tipo_status.id === 380
                ? "orange"
                : (arrData[i].tipo_status ? arrData[i].tipo_status.cor : "")
            ) +
            '">' +
            (arrData[i].tipo_status ? arrData[i].tipo_status.descricao: null) +
            "</span>",
          fdt: arrData[i].fdt,
          _data: arrData[i],
          buttons: [],
          options: {
            disable_delete:
              arrData[i].tipo_status &&
              [332, 330].indexOf(arrData[i].tipo_status.id) != -1 &&
              arrData[i].recibo &&
              this.$root.$session.validarPermissao(586)
                ? false
                : true,
          },
        };

        if (!arrData[i].recibo && !arrData[i].xml) {
          item.buttons.push({
            icon: "fa-solid fa-file-circle-plus",
            color: "default",
            title: "Gerar arquivo XML",
            style: "font-size:12px;color:" + (arrData[i].tipo_status ? arrData[i].tipo_status.cor : "#e03a3a"),
            click: this.parent.onEdit,
          });
        } else {

          item.buttons.push({
            icon: "fa fa-pen",
            color: "default",
            title: "Atualizar dados do evento",
            style: "color:#34c142",
            click: this.parent.onUpdateUid,
          });
          
          item.buttons.push({
            icon: "fa fa-download",
            color: "default",
            title: "Baixar arquivo XML",
            style: "color:#34c142",
            click: this.parent.onDownloadXML,
          });

          if (!arrData[i].lote) {
            item.buttons.push({
              icon: "fa fa-file-archive-o",
              color: "default",
              title: "Gerar novo lote para esse arquivo",
              style: "color:#666",
              click: this.parent.onGerarLote,
            });
          }

          if (!arrData[i].recibo && arrData[i].tipo_status.id != 380) {
            item.buttons.push({
              icon: "fa fa-refresh",
              color: "default",
              title: "Atualizar arquivo XML",
              style: "color:#568cdd",
              click: this.parent.onEdit,
            });
          }

          if (
            arrData[i].recibo &&
            arrData[i].tipo_status &&
            [332, 335].indexOf(arrData[i].tipo_status.id) != -1
          ) {
            item.buttons.push({
              icon: "fa fa-times-circle",
              color: "default",
              title: "Excluir arquivo XML",
              style: "color:#d82d2d",
              click: this.parent.onDelete,
            });
          }

          if (
            arrData[i].tipo_status &&
            arrData[i].tipo_status.id == 336 &&
            this.errosMatricula(arrData[i]).length &&
            (arrData[i].id_fun || (arrData[i].funcionario && arrData[i].funcionario.id))
          ) {
            item.buttons.push({
              icon: "fa fa-whatsapp",
              color: "info",
              title: "Erro do eSocial relacionado à matrícula/categoria do funcionário — enviar WhatsApp ao contador solicitando a correção.",
              click: this.parent.onDispararWhatsappAtualizarMatriculaContador,
            });
          }
        }

        if (
          arrData[i].motivo_falha_geracao == "SEM_MATRICULA" &&
          (arrData[i].id_fun || (arrData[i].funcionario && arrData[i].funcionario.id))
        ) {
          item.buttons.push({
            icon: "fa fa-whatsapp",
            color: "info",
            title: "Falha ao gerar XML por falta de matrícula — enviar WhatsApp ao contador solicitando a correção.",
            click: this.parent.onDispararWhatsappAtualizarMatriculaContador,
          });
        }

        tableData.push(item);
      }

      this.parent.tableData = tableData;
      this.parent.pagination = result.data;
    },
  },
};
</script>

<style lang="scss" scoped>
.esocial-modal-overlay {
  position: fixed;
  inset: 0;
  background: rgba(15, 23, 42, 0.45);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1500;
}

.esocial-modal {
  display: flex;
  flex-direction: column;
  background: #fff;
  border-radius: 16px;
  box-shadow: 0 24px 60px rgba(0, 0, 0, 0.25);
  width: 620px;
  max-width: 92vw;
  max-height: 85vh;
  overflow: hidden;
}

.esocial-modal__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 18px 22px;
  border-bottom: 3px solid rgba(168, 121, 31, 0.45);
}

.esocial-modal__title {
  font-size: 15px;
  font-weight: 700;
  color: #1f2329;
}

.esocial-modal__close {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  border: none;
  border-radius: 50%;
  background: #f1f2f4;
  color: #6b7280;
  font-size: 13px;
  cursor: pointer;
  transition: background-color 0.15s, color 0.15s;

  &:hover {
    background: #e4e7ed;
    color: #1f2329;
  }
}

.esocial-modal__body {
  padding: 20px 22px;
  overflow-y: auto;
  flex: 1 1 auto;
}

.esocial-modal__footer {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  padding: 16px 22px;
  border-top: 1px solid #eef0f2;
}

.esocial-modal-fade-enter-active,
.esocial-modal-fade-leave-active {
  transition: opacity 0.2s ease;
}

.esocial-modal-fade-enter,
.esocial-modal-fade-leave-to {
  opacity: 0;
}

.esocial-search__btn {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  height: 36px;
  box-sizing: border-box;
  padding: 0 14px;
  border: 1px solid #e4e7ed;
  background: #fff;
  border-radius: 8px;
  font-size: 12px;
  font-weight: 500;
  color: #374151;
  cursor: pointer;
  white-space: nowrap;
  transition: background-color 0.15s, border-color 0.15s;

  &:hover {
    background: #f7f8f9;
  }

  &--filter {
    color: rgb(168, 121, 31);
    border-color: #f0dfb8;
    background: #fdf8ee;

    &:hover {
      background: #f5e6c3;
    }
  }

  &--add {
    color: #1a8a3e;
    border-color: #bfe6cc;
    background: #eefbf1;
    margin-bottom: 10px;

    &:hover {
      background: #dcf4e3;
    }
  }
}

.procedimentos-table {
  overflow-x: auto;
  border: 1px solid #eef0f2;
  border-radius: 8px;

  table {
    width: 100%;
    border-collapse: collapse;
    font-size: 12px;
  }

  &--riscos table {
    min-width: 1100px;
  }

  thead th {
    text-align: left;
    padding: 9px 10px;
    background: #f0f1f3;
    color: #6b7280;
    font-size: 10px;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.03em;
    white-space: nowrap;
  }

  tbody tr {
    border-top: 1px solid #eef0f2;

    &:hover {
      background: #f7f9fb;
    }
  }

  td {
    padding: 6px 10px;
    vertical-align: middle;
    color: #1f2329;
  }

  &__col-codigo {
    width: 110px;
  }

  &__col-acoes {
    width: 50px;
  }

  &__empty {
    text-align: center;
    color: #9aa0a8;
    padding: 20px 0;
  }

  &__delete {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 26px;
    height: 26px;
    border: 1px solid transparent;
    background: transparent;
    border-radius: 6px;
    color: #c0392b;
    cursor: pointer;
    font-size: 11px;

    &:hover {
      background: #fff;
      border-color: #f3c9c9;
    }
  }
}
</style>



// WEBPACK FOOTER //
// s2240.vue?7b044904